<template>
    <div
        class="row row-sm"
        :style="`
            justify-content: ${justifyContent};
            width: 100%; 
            margin-left: 0;
        `">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'RowCardConfig',
    props: {
        // O tema inteiro era serializado aqui so para ler um alinhamento.
        // A view manda apenas o valor; `data` fica como fallback.
        justify: { type: String, default: null },
        data: { type: Object, default: null }
    },
    computed: {
        justifyContent() {
            return this.justify
                || this.data?.card_config?.justify_content
                || 'space-between'
        }
    }
}
</script>